import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import {
	type Control,
	Controller,
	type FieldValues,
	type Path
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { complianceConfirmationStyles as sx } from './ComplianceConfirmation.styles';

type Props<T extends FieldValues> = {
	control: Control<T>;
};

export const ComplianceConfirmation = <T extends FieldValues>({
	control
}: Props<T>) => {
	const { t } = useTranslation();

	return (
		<Box sx={sx.root}>
			<Controller
				name={'isThirdPartyDataConfirmed' as Path<T>}
				control={control}
				render={({ field: { value, onChange, ...rest } }) => (
					<FormControlLabel
						control={
							<Checkbox
								checked={!!value}
								onChange={onChange}
								{...rest}
								sx={sx.checkbox}
							/>
						}
						label={
							<Typography variant='body2' sx={sx.complianceConfirmationText}>
								{t(
									'I confirm that the information I am submitting via the form above, including any attachments, is based on my personal observations or interactions with an HCP/HCO, and is not based on any information my company licensed from another data provider.'
								)}
							</Typography>
						}
						sx={sx.checkboxFormControl}
					/>
				)}
			/>
		</Box>
	);
};
